import { Controller } from "@hotwired/stimulus";

export class FieldSortController extends Controller {
  static targets = ["field"];

  connect() {
    this.resetPosition();
  }

  moveUp(event) {
    const field = this.fieldTargets.find((field) => field.contains(event.target));
    if (!field) return;
    const prev = field.previousElementSibling;

    if (prev && prev.dataset.fieldSortTarget) {
      field.parentNode.insertBefore(field, prev);
      this.#swapPosition(field, prev);
    }
  }

  moveDown(event) {
    const field = this.fieldTargets.find((field) => field.contains(event.target));
    if (!field) return;
    const next = field.nextElementSibling;

    if (next && next.dataset.fieldSortTarget) {
      field.parentNode.insertBefore(next, field);
      this.#swapPosition(next, field);
    }
  }

  resetPosition() {
    for (let field of this.fieldTargets) {
      const position = field.querySelector("[name$='[position]']");
      position.value = this.fieldTargets.indexOf(field) + 1;
    }
  }

  #swapPosition(field_1, field_2) {
    const field1PositionInput = field_1.querySelector("[name$='[position]']");
    const field2PositionInput = field_2.querySelector("[name$='[position]']");
    const field1PositionValue = field1PositionInput.value;
    const field2PositionValue = field2PositionInput.value;
    field1PositionInput.value = field2PositionValue;
    field2PositionInput.value = field1PositionValue;
  }
}
